var _path, _path2, _path3, _path4, _path5, _circle, _ellipse, _ellipse2, _ellipse3, _circle2, _circle3, _path6, _path7, _g, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNotes = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 160,
  height: 161,
  viewBox: "0 0 160 161",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M98.58 35.028c-9.912-1.625-19.943-3.25-29.862-1.706-9.919 1.544-19.862 6.644-26.175 16.337-2.256 3.47-4.012 7.45-6.537 10.625-7.5 9.375-7.332 10.557-17.769 8.27-5.375-1.182-11.681-2.5-15.625 2.2-4.075 4.83-3.006 13.75.756 18.98 3.763 5.232 9.375 7.6 14.7 9.738 12.969 5.187 13.938 8.937 27.519 10.356 13.444 1.425 26.987-.537 40.456.431 11.613.832 23.069 3.832 34.675 4.813 11.607.981 23.75-.225 33.925-7.219 2.538-1.737 5.182-4.375 5.282-7.969.118-4.05-2.95-6.968-5.688-9.143l-12.012-9.563c-1.25-.975-2.538-2.081-3.007-3.8-.575-2.125.382-4.5 1.775-5.912 1.394-1.413 3.125-2.088 4.832-2.875 4.418-2.063 9.137-6.288 8.918-12.182a11.355 11.355 0 0 0-4.543-8.425c-2.419-1.818-5.232-2.593-7.994-3.318-13.088-3.457-30.331-7.057-43.531-9.77",
  fill: "url(#a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m132.587 61.534.481 2.457a2.707 2.707 0 0 1 1.482 1.98c.275 1.4-.45 2.72-1.613 2.945-1.162.225-2.331-.72-2.606-2.113a2.72 2.72 0 0 1 .625-2.4l-.331-1.762a68.978 68.978 0 0 1-22.719 7.5l-.2 3.312a2.71 2.71 0 0 1 .944 2.288c-.088 1.425-1.119 2.5-2.3 2.45-1.182-.05-2.082-1.25-1.994-2.7a2.713 2.713 0 0 1 1.206-2.17l.175-2.924a55.977 55.977 0 0 1-13.125-.219s5.869 7.613-11.2 54.175c0 0 13.175 7.706 31.413 5.538 18.237-2.169 30.468-7.5 30.468-7.5s13.25-27.663 1.707-69.607a70.115 70.115 0 0 1-12.413 8.75Z",
  fill: "url(#b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "m132.587 61.534.481 2.457a2.707 2.707 0 0 1 1.482 1.98c.275 1.4-.45 2.72-1.613 2.945-1.162.225-2.331-.72-2.606-2.113a2.72 2.72 0 0 1 .625-2.4l-.331-1.762a68.978 68.978 0 0 1-22.719 7.5l-.2 3.312a2.71 2.71 0 0 1 .944 2.288c-.088 1.425-1.119 2.5-2.3 2.45-1.182-.05-2.082-1.25-1.994-2.7a2.713 2.713 0 0 1 1.206-2.17l.175-2.924a55.977 55.977 0 0 1-13.125-.219s5.869 7.613-11.2 54.175c0 0 13.175 7.706 31.413 5.538 18.237-2.169 30.468-7.5 30.468-7.5s13.25-27.663 1.707-69.607a70.115 70.115 0 0 1-12.413 8.75Z",
  fill: "url(#c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M53.681 48.834s-7.306 38.788-44.15 45.2c0 0 50.238 49.132 80.206 42.738 29.969-6.394 53.388-75.238 53.957-85.863 0 0-71.194 12.207-90.013-2.075Z",
  fill: "url(#d)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m117.907 38.947-3.275.087c-10.063.1-22.144-1.112-34.375-5.45l-2.97-1.118a81.592 81.592 0 0 1-16.824-9.057s2.5 13.75-50.625 62.5c0 0 11.875 18.75 36.875 28.125s44.375 10.625 44.375 10.625 35.625-26.875 48.75-88.75c0 0-8.894 2.538-21.931 3.038Z",
  fill: "url(#e)"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60.813,
  cy: 58.134,
  r: 4.725,
  fill: "#DCE0E5"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 92.481,
  cy: 66.527,
  rx: 22.207,
  ry: 8.142,
  fill: "#DCE0E5"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 80.207,
  cy: 83.552,
  rx: 22.207,
  ry: 8.142,
  fill: "#DCE0E5"
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 66.207,
  cy: 100.552,
  rx: 22.207,
  ry: 8.142,
  fill: "#DCE0E5"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 48.938,
  cy: 73.134,
  r: 4.725,
  fill: "#DCE0E5"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 37.063,
  cy: 88.134,
  r: 4.725,
  fill: "#DCE0E5"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M113.041 75.43s-5.076 21.592-.846 40.916c0 0 25.389 8.342 34.582 21.12 0 0-8.456-29.402.586-35.313L113.041 75.43Z",
  fill: "url(#f)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M116.377 82.35s-4.816 10.447-1.497 25.6c0 0 19.9 6.536 27.119 16.554 0 0-4.719-17.356 2.37-21.972l-27.992-20.181Z",
  fill: "url(#g)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#h)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.594 87.254s16.092 22.779 36.16 33.513c0 0 23.864-21.473 41.22-21.473 0 0-31.826-14.047-31.3-28.745l-46.08 16.704Z",
  fill: "url(#i)"
}))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M57.957 89.07s6.259 13.652 21.993 22.042c0 0 18.701-16.813 32.331-16.813 0 0-18.592-8.58-18.18-20.117L57.957 89.07Z",
  fill: "url(#j)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 3.414,
  y1: 36.746,
  x2: 6.02,
  y2: 108.723,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C6EBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DDF4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 81.337,
  y1: 116.451,
  x2: 149.444,
  y2: 148.75,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 81.337,
  y1: 116.451,
  x2: 149.444,
  y2: 148.75,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3C4045"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3C4045",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 14.737,
  y1: 75.147,
  x2: 31.023,
  y2: 155.12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3C4045"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3C4045",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 1.578,
  y1: 62.133,
  x2: 38.974,
  y2: 163.622,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 143.211,
  y1: 70.414,
  x2: 106.106,
  y2: 74.669,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 76.953,
  y1: 98.752,
  x2: 110.826,
  y2: 109.088,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0AC39B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#008C78"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: 56.051,
  y1: 66.04,
  x2: 50.628,
  y2: 116.356,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "j",
  x1: 64.334,
  y1: 97.972,
  x2: 85.504,
  y2: 124.399,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0AC39B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#008C78"
})), /*#__PURE__*/React.createElement("filter", {
  id: "h",
  x: 34.594,
  y: 55.548,
  width: 107.38,
  height: 80.218,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4_10328"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4_10328",
  result: "shape"
})))));
export { SvgNotes as ReactComponent };
export default "data:image/svg+xml,%3csvg width='160' height='161' viewBox='0 0 160 161' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M98.58 35.028c-9.912-1.625-19.943-3.25-29.862-1.706-9.919 1.544-19.862 6.644-26.175 16.337-2.256 3.47-4.012 7.45-6.537 10.625-7.5 9.375-7.332 10.557-17.769 8.27-5.375-1.182-11.681-2.5-15.625 2.2-4.075 4.83-3.006 13.75.756 18.98 3.763 5.232 9.375 7.6 14.7 9.738 12.969 5.187 13.938 8.937 27.519 10.356 13.444 1.425 26.987-.537 40.456.431 11.613.832 23.069 3.832 34.675 4.813 11.607.981 23.75-.225 33.925-7.219 2.538-1.737 5.182-4.375 5.282-7.969.118-4.05-2.95-6.968-5.688-9.143l-12.012-9.563c-1.25-.975-2.538-2.081-3.007-3.8-.575-2.125.382-4.5 1.775-5.912 1.394-1.413 3.125-2.088 4.832-2.875 4.418-2.063 9.137-6.288 8.918-12.182a11.355 11.355 0 0 0-4.543-8.425c-2.419-1.818-5.232-2.593-7.994-3.318-13.088-3.457-30.331-7.057-43.531-9.77' fill='url(%23a)'/%3e%3cpath d='m132.587 61.534.481 2.457a2.707 2.707 0 0 1 1.482 1.98c.275 1.4-.45 2.72-1.613 2.945-1.162.225-2.331-.72-2.606-2.113a2.72 2.72 0 0 1 .625-2.4l-.331-1.762a68.978 68.978 0 0 1-22.719 7.5l-.2 3.312a2.71 2.71 0 0 1 .944 2.288c-.088 1.425-1.119 2.5-2.3 2.45-1.182-.05-2.082-1.25-1.994-2.7a2.713 2.713 0 0 1 1.206-2.17l.175-2.924a55.977 55.977 0 0 1-13.125-.219s5.869 7.613-11.2 54.175c0 0 13.175 7.706 31.413 5.538 18.237-2.169 30.468-7.5 30.468-7.5s13.25-27.663 1.707-69.607a70.115 70.115 0 0 1-12.413 8.75Z' fill='url(%23b)'/%3e%3cpath opacity='.2' d='m132.587 61.534.481 2.457a2.707 2.707 0 0 1 1.482 1.98c.275 1.4-.45 2.72-1.613 2.945-1.162.225-2.331-.72-2.606-2.113a2.72 2.72 0 0 1 .625-2.4l-.331-1.762a68.978 68.978 0 0 1-22.719 7.5l-.2 3.312a2.71 2.71 0 0 1 .944 2.288c-.088 1.425-1.119 2.5-2.3 2.45-1.182-.05-2.082-1.25-1.994-2.7a2.713 2.713 0 0 1 1.206-2.17l.175-2.924a55.977 55.977 0 0 1-13.125-.219s5.869 7.613-11.2 54.175c0 0 13.175 7.706 31.413 5.538 18.237-2.169 30.468-7.5 30.468-7.5s13.25-27.663 1.707-69.607a70.115 70.115 0 0 1-12.413 8.75Z' fill='url(%23c)'/%3e%3cpath opacity='.15' d='M53.681 48.834s-7.306 38.788-44.15 45.2c0 0 50.238 49.132 80.206 42.738 29.969-6.394 53.388-75.238 53.957-85.863 0 0-71.194 12.207-90.013-2.075Z' fill='url(%23d)'/%3e%3cpath d='m117.907 38.947-3.275.087c-10.063.1-22.144-1.112-34.375-5.45l-2.97-1.118a81.592 81.592 0 0 1-16.824-9.057s2.5 13.75-50.625 62.5c0 0 11.875 18.75 36.875 28.125s44.375 10.625 44.375 10.625 35.625-26.875 48.75-88.75c0 0-8.894 2.538-21.931 3.038Z' fill='url(%23e)'/%3e%3ccircle cx='60.813' cy='58.134' r='4.725' fill='%23DCE0E5'/%3e%3cellipse cx='92.481' cy='66.527' rx='22.207' ry='8.142' fill='%23DCE0E5'/%3e%3cellipse cx='80.207' cy='83.552' rx='22.207' ry='8.142' fill='%23DCE0E5'/%3e%3cellipse cx='66.207' cy='100.552' rx='22.207' ry='8.142' fill='%23DCE0E5'/%3e%3ccircle cx='48.938' cy='73.134' r='4.725' fill='%23DCE0E5'/%3e%3ccircle cx='37.063' cy='88.134' r='4.725' fill='%23DCE0E5'/%3e%3cpath d='M113.041 75.43s-5.076 21.592-.846 40.916c0 0 25.389 8.342 34.582 21.12 0 0-8.456-29.402.586-35.313L113.041 75.43Z' fill='url(%23f)'/%3e%3cpath d='M116.377 82.35s-4.816 10.447-1.497 25.6c0 0 19.9 6.536 27.119 16.554 0 0-4.719-17.356 2.37-21.972l-27.992-20.181Z' fill='url(%23g)'/%3e%3cg filter='url(%23h)'%3e%3cpath d='M49.594 87.254s16.092 22.779 36.16 33.513c0 0 23.864-21.473 41.22-21.473 0 0-31.826-14.047-31.3-28.745l-46.08 16.704Z' fill='url(%23i)'/%3e%3c/g%3e%3cpath d='M57.957 89.07s6.259 13.652 21.993 22.042c0 0 18.701-16.813 32.331-16.813 0 0-18.592-8.58-18.18-20.117L57.957 89.07Z' fill='url(%23j)'/%3e%3cdefs%3e%3clinearGradient id='a' x1='3.414' y1='36.746' x2='6.02' y2='108.723' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23C6EBFF'/%3e%3cstop offset='1' stop-color='%23DDF4FF'/%3e%3c/linearGradient%3e%3clinearGradient id='b' x1='81.337' y1='116.451' x2='149.444' y2='148.75' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23F5F5F5'/%3e%3cstop offset='1' stop-color='%23fff'/%3e%3c/linearGradient%3e%3clinearGradient id='c' x1='81.337' y1='116.451' x2='149.444' y2='148.75' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%233C4045'/%3e%3cstop offset='1' stop-color='%233C4045' stop-opacity='.1'/%3e%3c/linearGradient%3e%3clinearGradient id='d' x1='14.737' y1='75.147' x2='31.023' y2='155.12' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%233C4045'/%3e%3cstop offset='1' stop-color='%233C4045' stop-opacity='.1'/%3e%3c/linearGradient%3e%3clinearGradient id='e' x1='1.578' y1='62.133' x2='38.974' y2='163.622' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23F5F5F5'/%3e%3cstop offset='1' stop-color='%23fff'/%3e%3c/linearGradient%3e%3clinearGradient id='f' x1='143.211' y1='70.414' x2='106.106' y2='74.669' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23F5F5F5'/%3e%3cstop offset='1' stop-color='%23fff'/%3e%3c/linearGradient%3e%3clinearGradient id='g' x1='76.953' y1='98.752' x2='110.826' y2='109.088' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%230AC39B'/%3e%3cstop offset='1' stop-color='%23008C78'/%3e%3c/linearGradient%3e%3clinearGradient id='i' x1='56.051' y1='66.04' x2='50.628' y2='116.356' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23F5F5F5'/%3e%3cstop offset='1' stop-color='%23fff'/%3e%3c/linearGradient%3e%3clinearGradient id='j' x1='64.334' y1='97.972' x2='85.504' y2='124.399' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%230AC39B'/%3e%3cstop offset='1' stop-color='%23008C78'/%3e%3c/linearGradient%3e%3cfilter id='h' x='34.594' y='55.548' width='107.38' height='80.218' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset/%3e%3cfeGaussianBlur stdDeviation='7.5'/%3e%3cfeColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0'/%3e%3cfeBlend in2='BackgroundImageFix' result='effect1_dropShadow_4_10328'/%3e%3cfeBlend in='SourceGraphic' in2='effect1_dropShadow_4_10328' result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";